/**
 * @Author wutao
 * @description 课件新增编辑页面
 * @Date 2020/2/14
 */
import React from 'react';
import { connect } from 'dva';
import { component_tool, framework_tool, utils_tool } from '@/tool'
import moment from 'moment';
import './index.less'
import { Spin, Input } from "antd";
import { WizCourseUpdateContent } from '@/containers/common'
import { CourseUpdateListForm } from './components/courseUpdateList'

let { WizContainer, modelUtils } = framework_tool;
let { WizCard, WizForm, WizSpin, Wizmessage, WizButton } = component_tool;
let { Session } = utils_tool;
const { TextArea } = Input;

const brandList = [
  { value: 'B', label: '别克', id: 0 },
  { value: 'X', label: '雪佛兰', id: 1 },
  { value: 'K', label: '凯迪拉克', id: 2 },
  { value: 'O', label: '跨品牌', id: 9 }
]
const moduleList = [
  { value: 'S', label: '销售', id: 0 },
  { value: 'N', label: '售后服务', id: 1 },
  { value: 'T', label: '售后技术', id: 2 },
  { value: 'C', label: '诚新二手车', id: 3 },
  { value: 'X', label: '校企合作', id: 4 },
  { value: 'J', label: '集团销售', id: 5 },
  { value: 'O', label: '跨业务块', id: 9 }
]
const getCourseUpdateApplicationRecord = (history) => {
  let record;
  if (history.location && history.location.pathname === '/course/courseUpdateApplication') {
    if (history.location && history.location.record) {
      record = history.location.record;
      Session.set('courseUpdateApplicationRecord', record);
    } else {
      record = Session.get('courseUpdateApplicationRecord') ? Session.get('courseUpdateApplicationRecord') : {};
    }
  } else {
    if (history.location && history.location.record) {
      record = history.location.record;
      Session.set('courseUpdateApplicationUpd', record);
    } else {
      record = Session.get('courseUpdateApplicationUpd') ? Session.get('courseUpdateApplicationUpd') : {};
    }
  }
  return record
}
class ScheduleDetail extends WizContainer {

  componentName = 'ScheduleDetail';

  constructor(props) {
    super(props);
    const { history } = props;
    let initialValue = getCourseUpdateApplicationRecord(props.history);
    this.state = {
      programId: initialValue && initialValue.id,
      uploadDisabled: false,
      basicColumn: [],
      editList: [],
      outList: [],
      updateMark: '',
      formContentList: [],
      editData: {},
      versionInfo: {},
      initUpdateMark: '',
      initBasicColumn: [],
      resetNum: 1,
    };
    this.initialValue = initialValue;
    this.initialValue.personInfo = [];
    this.initialValue.courseware = [];
    this.clearWizCallBack = [];

  }

  _componentDidMount() {
    const { history } = this.props;
    if (this.initialValue && this.initialValue.lectureIds && this.initialValue.lectureIds.length > 0) {
      this.getPersonInfoByPersonIdList()
    }
    if (this.initialValue && this.initialValue.coursewareId && this.initialValue.coursewareId != -1) {
      this.getCoursewareById();
    }
    if (history.location && history.location.pathname === '/course/courseUpdateApplicationUpd') {
      if (history.location && history.location.record) {
        applicationInfo = history.location.record
        Session.set('courseUpdateApplicationUpd', applicationInfo)
      } else {
        applicationInfo = Session.get('courseUpdateApplicationUpd') || {}
      }
      this.getEditInfo({ id: applicationInfo.id })
    } else {
      if (this.state.programId) {
        this.getProgramInfo();
        this.getProgramContent();
        this.getNewConfirmedInfo();
      }
    }

  }

  propsAndStateOnChange = {
    addSchedule: this._addScheduleOver.bind(this),
    updateSchedule: this._updateScheduleOver.bind(this),
    personInfo: this._getPersonInfoOver.bind(this),
    courseware: this._getCoursewareByIdOver.bind(this),
    getProgramInfo: this._getProgramInfoOver.bind(this),
    getProgramEntityList: this._getProgramEntityListOver.bind(this),
    getInfo: this._getInfoOver.bind(this),
    newConfirmedInfo: this._newConfirmedInfoOver.bind(this),
    addCourseApplication: this._addCourseApplicationOver.bind(this),
    updateCourseApplication: this._updateCourseApplicationOver.bind(this),
  };

  getEditInfo(params) {
    this.doAction({
      path: 'courseApplication/getInfo',
      payload: {
        key: 'getInfo',
        apiParams: {
          ...params
        }
      }
    });
  }
  /**获取课程内容 */
  getProgramContent() {
    this.doAction({
      path: 'programEntity/getListByProgramId',
      payload: {
        key: 'getProgramEntityList',
        apiParams: {
          programId: this.state.programId,
        }
      }
    });
  }
  getNewConfirmedInfo = (params = {}) => {
    this.doActions([
      {
        path: 'courseApplication/newConfirmedInfo',
        payload: {
          key: `courseApplication@newConfirmedInfo`,
          apiParams: { programId: this.state.programId, ...params }
        }
      }
    ])
  }
  /**获取课程信息 */
  getProgramInfo() {
    this.doAction({
      path: 'program/getProgramById',
      payload: {
        key: 'getProgramById',
        apiParams: {
          id: this.state.programId,
        }
      }
    });
  }
  _newConfirmedInfoOver(nextProps, nextState) {
    const { newConfirmedInfo } = nextProps;
    if (newConfirmedInfo.success) {
      nextState.versionInfo = newConfirmedInfo.data
      return true;
    } else {
      // wizNotice.error(newConfirmedInfo.msg);
    }
    return false;
  }
  _getInfoOver(nextProps, nextState) {
    if (nextProps.getInfo.code === 1) {
      this.initialValue = nextProps.getInfo.data
      nextState.editList = nextProps.getInfo.data.detailValue.contentList
      nextState.updateMark = nextProps.getInfo.data.updateMark
      nextState.initUpdateMark = nextProps.getInfo.data.updateMark
      nextState.basicColumn = JSON.parse(JSON.stringify(this.formatEditBasic(nextProps.getInfo.data)))
      nextState.initBasicColumn = JSON.parse(JSON.stringify(this.formatEditBasic(nextProps.getInfo.data)))
    } else {
      wizNotice.error(nextProps.getInfo.msg);
    }
    return true
  }
  _updateCourseApplicationOver(nextProps, nextState) {
    if (nextProps.updateCourseApplication.code === 1) {
      this.jumpPage('replace', '/course/programApplication');
    } else {
      wizNotice.error(nextProps.updateCourseApplication.msg);
    }
    return true
  }

  _addCourseApplicationOver(nextProps, nextState) {
    if (nextProps.addCourseApplication.code === 1) {
      this.jumpPage('replace', '/course/programApplication');
    } else {
      wizNotice.error(nextProps.addCourseApplication.msg);
    }
    return true
  }
  _getProgramInfoOver(nextProps, nextState) {
    if (nextProps.getProgramInfo.code === 1) {
      nextState.basicColumn = JSON.parse(JSON.stringify(this.formatBasic(nextProps.getProgramInfo.data)))
      nextState.initBasicColumn = JSON.parse(JSON.stringify(this.formatBasic(nextProps.getProgramInfo.data)))
    } else {
      wizNotice.error(nextProps.getProgramInfo.msg);
    }
    return true
  }

  _getProgramEntityListOver(nextProps, nextState) {
    if (nextProps.getProgramEntityList.code == 1) {
      nextState.programContent = nextProps.getProgramEntityList.data;
      if (nextProps.getProgramEntityList.data && nextProps.getProgramEntityList.data instanceof Array) {
        nextState.outList = nextProps.getProgramEntityList.data
      }
    }
    return true;
  }
  /**获取对应的讲师数据，讲师选择组件需要显示默认值 */
  getPersonInfoByPersonIdList() {
    this.doAction({
      path: 'personManage/getPersonInfoByPersonIdList',
      payload: {
        key: 'getPersonInfoByPersonIdList',
        apiParams: {
          personIdList: this.initialValue.lectureIds,
        }
      }
    });
  }

  /**查看时时获取对应的评语考核内容明细数据 */
  getCoursewareById() {
    this.doAction({
      path: 'coursewareManagement/selectOneById',
      payload: {
        key: 'coursewareManagement@coursewareInfo',
        apiParams: {
          id: this.initialValue.coursewareId,
        }
      }
    });
  }

  /**
   * 将查询到的人员选项加载到记录中
   */
  _getPersonInfoOver(nextProps, nextState) {
    let personInfo = nextProps.personInfo.data;
    if (nextProps.personInfo.code == 1 && personInfo && personInfo.length) {
      this.initialValue.personInfo = personInfo;
    }
    return true;
  }

  /**
   * 查询到的课件信息
   */
  _getCoursewareByIdOver(nextProps, nextState) {
    let courseware = nextProps.courseware.data;
    if (nextProps.courseware.code == 1 && courseware && courseware.id && courseware.name) {
      this.initialValue.courseware = [courseware];
    }
    return true;
  }

  /**
   * 课件新增成功返回原页面，失败弹出提示
   */
  _addScheduleOver(nextProps, nextState) {
    if (nextProps.addSchedule.code == 1) {
      wizNotice.success('保存成功');
      this.jumpPage('replace', '/program/scheduleList');
    } else {
      wizNotice.error('提交失败：' + nextProps.addSchedule.msg);
    }
    return true;
  }

  /**
   * 课件修改成功返回原页面，失败弹出提示
   */
  _updateScheduleOver(nextProps, nextState) {
    if (nextProps.updateSchedule.code == 1) {
      wizNotice.success('保存成功');
      this.jumpPage('replace', '/program/scheduleList');
    } else {
      wizNotice.error('提交失败：' + nextProps.updateSchedule.msg);
    }
    return true;
  }
  formatDate = (date, type) => {
    let desc = ''
    if (type = 'start') {
      desc = date[0]
    } else {
      desc = date[1]
    }
    return desc
  }
  formatCategoryId = (value) => {
    let desc = []
    if (value?.length > 0) {
      desc = value.map(item => item.key)
    }
    return desc.length < 1 ? null : desc
  }
  formatTargetScope = (authCmd) => {
    let desc = {}
    if (authCmd["groupId"] && authCmd["groupId"].length > 0) {
      desc.groupId = Number(authCmd?.groupId?.map((p) => p["id"]).toString());
    } else if (authCmd.orgIds?.length > 0 || authCmd.positionIds?.length > 0 || authCmd.positionCategoryIds?.length > 0 || authCmd.personIds?.length > 0) {
      desc.orgIds = authCmd?.orgIds?.map((p) => p["id"]);
      desc.positionIds = authCmd?.positionIds?.map((p) => p["id"]);
      desc.positionCategoryIds = authCmd?.positionCategoryIds?.map((p) => p["id"])
      desc.personIds = authCmd?.personIds?.map((p) => p["id"])
    }
    return Object.keys(desc).length < 1 ? null : desc
  }
  _resetValue = (form) => {
    const { getFieldDecorator, validateFields, setFields, resetFields, getFieldsValue } = form
    let { initUpdateMark, resetNum } = this.state
    let initBasicColumnCopy = JSON.parse(JSON.stringify(this.state.initBasicColumn))
    resetFields()
    this.setState({ updateMark: initUpdateMark, basicColumn: initBasicColumnCopy, resetNum: resetNum + 1 })
  }
  /**
   * 保存/更新 课件信息
   * @param values
   * @private
   */
  _saveSchedule(form) {
    const { getFieldDecorator, validateFields, setFields, resetFields, getFieldsValue } = form
    validateFields((err, values) => {
      if (!err) {
        let { updateMark, basicColumn, formContentList, outList, editList, programId } = this.state
        // resetFields()
        if (!basicColumn || basicColumn?.length == 0) {
          Wizmessage.error('请更新课程内容');
          return
        }
        let course1 = basicColumn.find(x => x.title == '品牌')
        if (!course1.beforeValue && course1.beforeValue != 0 && !course1.afterValue && course1.afterValue != 0) {
          Wizmessage.error('请调整品牌');
          return

        }
        let course2 = basicColumn.find(x => x.title == '功能块')
        if (!course2.beforeValue && course2.beforeValue != 0 && !course2.afterValue && course2.afterValue != 0) {
          Wizmessage.error('请调整功能块');
          return

        }
        let course = basicColumn.find(x => x.title == '序号')
        if (!course.beforeValue && !course.afterValue) {
          Wizmessage.error('请调整序号');
          return
        }
        let courseB = basicColumn.find(x => x.title == '开发/更新完成时间')
        if (!courseB.beforeValue && !courseB.afterValue) {
          Wizmessage.error('请调整开发/更新完成时间');
          return
        }
        let courseC = basicColumn.find(x => x.title == '课程编码')
        if (!courseC.beforeValue && !courseC.afterValue) {
          Wizmessage.error('请调整课程编码');
          return
        }
        if (!updateMark) {
          Wizmessage.error('请输入更新说明');
          return
        }

        values.updateMark = updateMark
        let programNameObj = basicColumn.find(x => x.title == '课程名称')
        let programSourceObj = basicColumn.find(x => x.title == '课程来源')
        let moduleObj = basicColumn.find(x => x.title == '功能块')
        let brandObj = basicColumn.find(x => x.title == '品牌')
        let orderNumberObj = basicColumn.find(x => x.title == '序号')
        let versionNumberObj = basicColumn.find(x => x.title == '版本号')
        let programFinishDateObj = basicColumn.find(x => x.title == '开发/更新完成时间')
        let programScoIdObj = basicColumn.find(x => x.title == '课程编码')
        let dateObj = basicColumn.find(x => x.title == '课程时间')
        let programCategoryIdListObj = basicColumn.find(x => x.title == '课程分类')
        let imgOneObj = basicColumn.find(x => x.title == '封面')
        let introObj = basicColumn.find(x => x.title == '介绍')
        let targetScopeObj = basicColumn.find(x => x.title == '受众')
        let beforeDetail = {
          "programId": this.initialValue?.detailValue?.beforeDetail?.programId ? this.initialValue.detailValue.beforeDetail?.programId : programId,
          "module": moduleObj.beforeValue,
          "brand": brandObj.beforeValue,
          "programSource": programSourceObj.beforeValue,
          "orderNumber": orderNumberObj.beforeValue,
          "versionNumber": versionNumberObj.beforeValue,
          "startDate": this.formatDate(dateObj.beforeValue, 'start'),
          "endDate": this.formatDate(dateObj.beforeValue, 'end'),
          "programScoId": programScoIdObj.beforeValue,
          "programFinishDate": programFinishDateObj.beforeValue ? moment(programFinishDateObj.beforeValue).format('YYYY-MM-01 00:00:00') : '',
          "programName": programNameObj.beforeValue,
          "programCategoryIdList": this.formatCategoryId(programCategoryIdListObj.beforeValue),
          "imgOne": imgOneObj.beforeValue,
          "targetScope": this.formatTargetScope(targetScopeObj.beforeValue),
          "intro": introObj.beforeValue,
        }
        let detail = {
          "module": moduleObj.afterValue,
          "brand": brandObj.afterValue,
          "programSource": programSourceObj.afterValue,
          "orderNumber": orderNumberObj.afterValue,
          "versionNumber": versionNumberObj.afterValue,
          "startDate": this.formatDate(dateObj.afterValue, 'start'),
          "endDate": this.formatDate(dateObj.afterValue, 'end'),
          "programScoId": programScoIdObj.afterValue,
          "programFinishDate": programFinishDateObj.afterValue,
          "programName": programNameObj.afterValue,
          "programCategoryIdList": this.formatCategoryId(programCategoryIdListObj.afterValue),
          "imgOne": imgOneObj.afterValue,
          "targetScope": this.formatTargetScope(targetScopeObj.afterValue),
          "intro": introObj.afterValue,
        }
        let changeData = {
          "module": moduleObj.adjust,
          "brand": brandObj.adjust,
          "programSource": programSourceObj.adjust,
          "orderNumber": orderNumberObj.adjust,
          "versionNumber": versionNumberObj.adjust,
          "startDate": dateObj.adjust,
          "endDate": dateObj.adjust,
          "programScoId": programScoIdObj.adjust,
          "programFinishDate": programFinishDateObj.adjust,
          "programName": programNameObj.adjust,
          "programCategoryIdList": programCategoryIdListObj.adjust,
          "imgOne": imgOneObj.adjust,
          "targetScope": targetScopeObj.adjust,
          "intro": introObj.adjust,
        }
        let outListArr = []

        if (formContentList?.length > 0) {
          outListArr = formContentList
        } else if (outList?.length > 0) {
          outList.forEach((item, index) => {
            let { orderNum, type, title, entityId, code } = item
            outListArr.push({ orderNum, contentType: type, originalName: title, originalId: entityId, originalCode: code, dataChange: 0 })
          })
        } else if (editList?.length > 0) {
          outListArr = editList
        }

        values.detailValueEntity = { detail, beforeDetail, changeData, contentList: outListArr }
        values.applyType = 1
        values.applicant = storage.getStorage('user').personId
        const { history } = this.props;
        let apiPath
        let payloadKey
        if (history.location && history.location.pathname === '/course/courseUpdateApplicationUpd') {
          values.id = programId
          apiPath = "courseApplication/update";
          payloadKey = "updateCourseApplication";
        } else {
          values.id = null
          apiPath = "courseApplication/add";
          payloadKey = "addCourseApplication";
        }
        this.doAction({
          path: apiPath,
          payload: {
            key: payloadKey,
            apiParams: {
              ...values
            }
          }
        });
      }
    });
  }

  /**讲师验证 */
  lecturesValidator = (rule, value, callback) => {
    //const { getFieldValue } = this.props.form; //可以获取form其他的值getFieldValue('a')
    if (value && value.length > 10) {
      callback('讲师最多选择10个')
    }
    // 必须总是返回一个 callback，否则 validateFields 无法响应
    callback();
  }
  _onClearWiz(callback) {
    if (callback) {
      this.clearWizCallBack.push(callback)
    }
  }
  formatScoId = (form, brandVal, moduleVal, orderNumberVal, dateString, versionNumber) => {

    // let { getFieldsValue, setFieldsValue } = form
    let newScoId = ''
    let programFinishDate = dateString
    let brand = brandVal
    let module = moduleVal
    let orderNumber = orderNumberVal.toString()
    if ((brand || brand == 0) && (module || module == 0) && orderNumber && orderNumber.length == 4 && programFinishDate) {
      let brandDesc = brandList.find(x => x.id == brand).value
      let moduleDesc = moduleList.find(x => x.id == module).value
      let orderNumberDesc = orderNumber
      let arr = programFinishDate.split('-')
      let programFinishDateDesc;
      if (arr.length > 1) {
        programFinishDateDesc = arr[0] + arr[1]
      }
      newScoId = brandDesc + moduleDesc + orderNumberDesc + versionNumber + programFinishDateDesc
    }
    return newScoId
  }
  _scheduleColumns = () => {
    let columns = []
    let initialValue = this.initialValue;
    initialValue.versionNumber = 'V1.0'
    const { startDate, endDate, applicantName = storage.getStorage('user').fullName } = initialValue;
    let initialDate = [];
    if (startDate && endDate) {
      initialDate.push(startDate);
      initialDate.push(endDate);
    }
    let _baseColumns1 = [
      {
        formItem: {
          type: "hidden",
          initialValue: initialValue.id
        },
        name: "id"
      },
      {
        title: "培训公司名称",
        name: "trainCompanyName",
        formItem: {
          initialValue: initialValue.trainCompanyName,
          rules: [
            {
              required: true,
              message: '请输入',
            }, {
              max: 30,
              message: '名称长度不能超过30个字符'
            }
          ],
          placeholder: "请输入"
        }
      },
      {
        title: "申请人",
        name: "name",
        formItem: {
          type: 'custom',
          initialValue: applicantName,
          render: (record, form) => {
            const { getFieldDecorator } = form;
            return (
              <>
                {getFieldDecorator('applicantName', {
                  initialValue: applicantName,
                  rules: [{ required: true, message: '' }],
                })(
                  <p>
                    {applicantName}
                  </p>,
                )}
              </>
            )
          }
        }
      },
      {
        title: "联系电话",
        name: "telephone",
        formItem: {
          initialValue: initialValue.telephone,
          type: 'number',
          rules: [
            {
              required: true,
              message: '请输入',
            },
            {
              validator: (rule, value, callback) => {
                if (value < 0 || value && (value.toString().length != 11 || value.toString().indexOf('.') > -1)) {
                  callback('请输入正确的手机号')
                }
                callback();
              }
            }
          ],
          placeholder: "请输入"
        }
      },
      {
        title: "",
        name: "",
        formItem: {
          type: 'custom',
          render: (record, form) => {
            const { getFieldDecorator } = form;
            return (
              <>

                <WizButton id='confrim-btn' style={{ display: 'none' }} onClick={() => this._saveSchedule(form)}>确认</WizButton>
                <WizButton id='reset-btn' style={{ display: 'none' }} onClick={() => this._resetValue(form)}>重置</WizButton>
              </>
            )
          }
        }
      },

    ]
    columns = [..._baseColumns1]
    return columns;
  }
  confirm = () => {
    document.getElementById("confrim-btn").click()
  }
  resetBtn = () => {
    document.getElementById("reset-btn").click()
  }
  antiParsingScoId = (scoId, type) => {
    let desc = ''
    let programFinishDateM = ''
    let programFinishDateY = ''
    let orderNumber = ''
    if (scoId.toString().length == 14) {
      if (scoId.slice(2, 6) && scoId.slice(6, 8) && scoId.slice(8, 12)) {
        orderNumber = scoId.slice(2, 6)
        programFinishDateY = scoId.slice(8, 12)
        programFinishDateM = scoId.slice(12, 14)
      }
      if (programFinishDateY && programFinishDateM && orderNumber) {
        if (type == 'programFinishDate') {
          desc = programFinishDateY + '-' + programFinishDateM
        } else if (type == 'orderNumber') {
          desc = orderNumber
        }
      }
    }

    return desc
  }

  formatEditBasic = (data) => {
    if (data) {
      let { detailValue } = data
      let { beforeDetail, changeData, detail } = detailValue
      let arrList = [
        {
          title: '课程名称',
          beforeValue: beforeDetail.programName,
          adjust: changeData.programName,
          afterValue: detail.programName
        },
        {
          title: '课程来源',
          beforeValue: beforeDetail.programSource,
          adjust: changeData.programSource,
          afterValue: detail.programSource
        },
        {
          title: '品牌',
          beforeValue: beforeDetail.brand,
          adjust: changeData.brand,
          afterValue: detail.brand
        },
        {
          title: '功能块',
          beforeValue: beforeDetail.module,
          adjust: changeData.module,
          afterValue: detail.module
        },
        {
          title: '序号',
          beforeValue: beforeDetail.orderNumber,
          adjust: changeData.orderNumber,
          afterValue: detail.orderNumber
        },
        {
          title: '开发/更新完成时间',
          beforeValue: beforeDetail.programFinishDate,
          adjust: changeData.programFinishDate,
          afterValue: detail.programFinishDate
        },
        {
          title: '版本号',
          beforeValue: beforeDetail.versionNumber,
          adjust: changeData.versionNumber,
          afterValue: detail.versionNumber
        },
        {
          title: '课程编码',
          beforeValue: beforeDetail.programScoId,
          adjust: changeData.programScoId,
          afterValue: detail.programScoId
        },
        {
          title: '课程时间',
          beforeValue: beforeDetail.startDate && beforeDetail.endDate ? [beforeDetail.startDate, beforeDetail.endDate] : [],
          adjust: changeData.startDate == 1 || changeData.endDate == 1 ? 1 : 0,
          afterValue: detail.startDate && detail.endDate ? [detail.startDate, detail.endDate] : [],
        },
        {
          title: '课程分类',
          beforeValue: beforeDetail.programCategory,
          adjust: changeData.programCategoryIdList,
          afterValue: detail.programCategory
        },
        {
          title: '封面',
          beforeValue: beforeDetail.imgOne,
          adjust: changeData.imgOne,
          afterValue: detail.imgOne
        },
        {
          title: '介绍',
          beforeValue: beforeDetail.intro,
          adjust: changeData.intro,
          afterValue: detail.intro
        },
        {
          title: '受众',
          beforeValue: beforeDetail.authData,
          adjust: changeData.targetScope,
          afterValue: detail.authData
        },
      ]
      return arrList
    }
  }
  formatBasic = ({ name, programSource, brand, module, scoId, programCategory, programCategoryIds, programCategoryNames, startDate, endDate, imgOne, intro, authData }) => {
    let { versionInfo } = this.state
    let beforeVersion = versionInfo.versionNumber ? versionInfo.versionNumber : 'V1.0'
    let afterVersion = ''
    let arr = []
    if (beforeVersion) {
      arr = beforeVersion.split('.')
      afterVersion = Number(arr[0].split('V')[1]) + 1
      afterVersion = 'V' + afterVersion + '.0'
    } else {
      afterVersion = 'V1.0'
    }
    let afterVersionSco = afterVersion?.split('.')[0]
    let afterScoId = ''
    if ((brand || brand == 0) && (module || module == 0) && this.antiParsingScoId(scoId, 'orderNumber') && this.antiParsingScoId(scoId, 'programFinishDate')) {
      afterScoId = this.formatScoId(null, brand, module, this.antiParsingScoId(scoId, 'orderNumber'), this.antiParsingScoId(scoId, 'programFinishDate'), afterVersionSco)
    }
    let arrList = [
      {
        title: '课程名称',
        beforeValue: name,
        adjust: 0,
        afterValue: ''
      },
      {
        title: '课程来源',
        beforeValue: programSource,
        adjust: 0,
        afterValue: ''
      },
      {
        title: '品牌',
        beforeValue: brand,
        adjust: 0,
        afterValue: ''
      },
      {
        title: '功能块',
        beforeValue: module,
        adjust: 0,
        afterValue: ''
      },
      {
        title: '序号',
        beforeValue: this.antiParsingScoId(scoId, 'orderNumber'),
        adjust: 0,
        afterValue: ''
      },
      {
        title: '开发/更新完成时间',
        beforeValue: this.antiParsingScoId(scoId, 'programFinishDate'),
        adjust: 0,
        afterValue: ''
      },
      {
        title: '版本号',
        beforeValue: beforeVersion,
        adjust: 1,
        afterValue: afterVersion
      },
      {
        title: '课程编码',
        beforeValue: scoId,
        adjust: afterScoId ? 1 : 0,
        afterValue: afterScoId
      },
      {
        title: '课程时间',
        beforeValue: [startDate, endDate],
        adjust: 0,
        afterValue: ''
      },
      {
        title: '课程分类',
        beforeValue: programCategory,
        adjust: 0,
        afterValue: ''
      },
      {
        title: '封面',
        beforeValue: imgOne,
        adjust: 0,
        afterValue: ''
      },
      {
        title: '介绍',
        beforeValue: intro,
        adjust: 0,
        afterValue: ''
      },
      {
        title: '受众',
        beforeValue: authData,
        adjust: 0,
        afterValue: ''
      },
    ]
    return arrList
  }

  onerFormatScoId = (brandVal, moduleVal, orderNumberVal, dateString, versionNumberVal, brandCancel, moduleCancel, orderNumberCancel, dateStringCancel) => {
    let data = JSON.parse(JSON.stringify(this.state.basicColumn))
    let desc = ''

    let brand = ''
    if (brandCancel) {
      brand = data.find(x => x.title == '品牌').beforeValue
    } else {
      brand = brandVal || brandVal === 0 ? brandVal : (data.find(x => x.title == '品牌').afterValue || data.find(x => x.title == '品牌').afterValue === 0 ? data.find(x => x.title == '品牌').afterValue : data.find(x => x.title == '品牌').beforeValue)
    }
    let module = ''
    if (moduleCancel) {
      module = data.find(x => x.title == '功能块').beforeValue
    } else {
      module = moduleVal || moduleVal === 0 ? moduleVal : (data.find(x => x.title == '功能块').afterValue || data.find(x => x.title == '功能块').afterValue === 0 ? data.find(x => x.title == '功能块').afterValue : data.find(x => x.title == '功能块').beforeValue)
    }
    let orderNumber = ''
    if (orderNumberCancel) {
      orderNumber = data.find(x => x.title == '序号').beforeValue?.toString()
    } else {
      orderNumber = orderNumberVal ? orderNumberVal.toString() : (data.find(x => x.title == '序号').afterValue ? data.find(x => x.title == '序号').afterValue?.toString() : data.find(x => x.title == '序号').beforeValue?.toString())
    }
    let programFinishDate = ''
    if (dateStringCancel) {
      programFinishDate = moment(data.find(x => x.title == '开发/更新完成时间').beforeValue).format("YYYY-MM")
    } else {
      if (dateString) {
        programFinishDate = dateString
      } else if (!dateString && (data.find(x => x.title == '开发/更新完成时间').afterValue || data.find(x => x.title == '开发/更新完成时间').beforeValue)) {
        programFinishDate = data.find(x => x.title == '开发/更新完成时间').afterValue ? moment(data.find(x => x.title == '开发/更新完成时间').afterValue).format("YYYY-MM") : moment(data.find(x => x.title == '开发/更新完成时间').beforeValue).format("YYYY-MM")
      }
    }
    let versionNumber = versionNumberVal ? versionNumberVal.split('.')[0] : data.find(x => x.title == '版本号').afterValue.split('.')[0]
    if ((brand || brand === 0) && (module || module === 0) && orderNumber && orderNumber.length <= 4 && programFinishDate) {
      let brandDesc = brandList.find(x => x.id == brand).value
      let moduleDesc = moduleList.find(x => x.id == module).value
      let orderNumberDesc = orderNumber
      for (let i = 0; i < 3; i++) {
        if (orderNumberDesc.length < 4) {
          orderNumberDesc = '0' + orderNumberDesc
        }
      }
      let arr = programFinishDate.split('-')
      let programFinishDateDesc;
      if (arr.length > 1) {
        programFinishDateDesc = arr[0] + arr[1]
      }
      desc = brandDesc + moduleDesc + orderNumberDesc + versionNumber + programFinishDateDesc
    }
    return desc
  }
  submit = (values, type) => {
    let basicColumnCopy = JSON.parse(JSON.stringify(this.state.basicColumn))
    let eIndex = basicColumnCopy.findIndex(x => x.title == values.title)
    let eItem = basicColumnCopy.find(x => x.title == values.title)
    if (type == 2) {
      basicColumnCopy.splice(eIndex, 1, { ...eItem, afterValue: '', adjust: 0 })
    } else {
      basicColumnCopy.splice(eIndex, 1, { ...eItem, afterValue: values.value, adjust: 1 })
    }
    let scoIdIndex = basicColumnCopy.findIndex(x => x.title == '课程编码')
    let scoIdItem = basicColumnCopy.find(x => x.title == '课程编码')
    if (values.title == '品牌') {
      if (type == 2) {
        basicColumnCopy.splice(scoIdIndex, 1, {
          ...scoIdItem, afterValue: this.onerFormatScoId(values.value, null, null, null, null, true),
          adjust: this.onerFormatScoId(values.value, null, null, null, null, true) ? 1 : 0
        })
      } else {
        basicColumnCopy.splice(scoIdIndex, 1, { ...scoIdItem, afterValue: this.onerFormatScoId(values.value), adjust: 1 })
      }
    } else if (values.title == '功能块') {
      if (type == 2) {
        basicColumnCopy.splice(scoIdIndex, 1, {
          ...scoIdItem, afterValue: this.onerFormatScoId(null, values.value, null, null, null, false, true),
          adjust: this.onerFormatScoId(null, values.value, null, null, null, false, true) ? 1 : 0
        })
      } else {
        basicColumnCopy.splice(scoIdIndex, 1, { ...scoIdItem, afterValue: this.onerFormatScoId(null, values.value), adjust: 1 })
      }
    } else if (values.title == '序号') {
      if (type == 2) {
        basicColumnCopy.splice(scoIdIndex, 1, {
          ...scoIdItem, afterValue: this.onerFormatScoId(null, null, values.value, null, null, false, false, true),
          adjust: this.onerFormatScoId(null, null, values.value, null, null, false, false, true) ? 1 : 0
        })
      } else {
        basicColumnCopy.splice(scoIdIndex, 1, { ...scoIdItem, afterValue: this.onerFormatScoId(null, null, values.value), adjust: 1 })
      }
    } else if (values.title == '开发/更新完成时间') {
      if (type == 2) {
        basicColumnCopy.splice(scoIdIndex, 1, { ...scoIdItem, afterValue: this.onerFormatScoId(null, null, null, values.value, null, false, false, false, true), adjust: this.onerFormatScoId(null, null, null, values.value, null, false, false, false, true) ? 1 : 0 })
      } else {
        basicColumnCopy.splice(scoIdIndex, 1, { ...scoIdItem, afterValue: this.onerFormatScoId(null, null, null, values.value), adjust: 1 })
      }
    } else if (values.title == '版本号') {
      basicColumnCopy.splice(scoIdIndex, 1, { ...scoIdItem, afterValue: this.onerFormatScoId(null, null, null, null, values.value), adjust: 1 })
    }
    this.setState({ basicColumn: basicColumnCopy })
  }

  contentOnChange = (values) => {
    let arr = []
    if (values?.length > 0) {
      values.forEach(item => {
        arr.push({ ...item, fileId: item.fileId ? item.fileId[0]?.fileId : '' })
      })
    }
    this.setState({ formContentList: arr })
  }
  _render() {
    const { scheduleManagementLoading, personManageLoading, coursewareManagementLoading } = this.props;
    const { basicColumn, outList, editList, updateMark, initBasicColumn, resetNum } = this.state;
    let initialValue = this.initialValue;
    let cardTitle = '新增';
    if (initialValue && initialValue.id) {
      cardTitle = '编辑';
    }
    let columns = this._scheduleColumns();
    let onSubmit = this._saveSchedule.bind(this);
    let formProps = {
      ref: 'form',
      columns,
      onSubmit,
      record: null,
      preview: null,
      footer: null,
      formItemLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 12 }
      },
      style: { maxWidth: '100%', width: '100%' }
    }

    return (
      <div key={'course-update-application'} className='course-update-application'>
        <Spin tip={'加载中'} spinning={scheduleManagementLoading || personManageLoading || coursewareManagementLoading}>
          <WizCard title="用户基础信息">
            <WizForm key={'schedule-detail-edit-form'} className={'form-inline'} {...formProps} />
          </WizCard>
          <WizCard title="课程基本信息">
            <div className='card-box'>
              <div className='star-box'>
                <span className='red-star'>*</span>课程基本信息调整：
              </div>
              <CourseUpdateListForm data={basicColumn} submit={this.submit}></CourseUpdateListForm>
              <div className='star-box'>
                <span className='red-star'>*</span>更新说明：
              </div>
              <TextArea placeholder='请输入' value={updateMark} onChange={(e) => { this.setState({ updateMark: e.target.value }) }}></TextArea >
            </div>
          </WizCard>
          <WizCard title="课件基本信息" >
            <div className='card-box'>
              <WizCourseUpdateContent resetNum={resetNum} editList={editList} outList={outList} onChange={this.contentOnChange}></WizCourseUpdateContent>
            </div>
          </WizCard>
          <div className='bottom-box'>
            <WizButton className='bottom-btn' type='primary' onClick={() => this.confirm()}>确认</WizButton>
            <WizButton className='bottom-btn' onClick={() => this.resetBtn()}>重置</WizButton>
          </div>
        </Spin>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { scheduleManagement, coursewareManagement, personManage, courseApplication, program, programEntity } = state;
  const getInfo = modelUtils.getModelEntity(courseApplication, "getInfo");
  const newConfirmedInfo = modelUtils.getModelEntity(courseApplication, `courseApplication@newConfirmedInfo`);
  const addCourseApplication = modelUtils.getModelEntity(courseApplication, "addCourseApplication");
  const updateCourseApplication = modelUtils.getModelEntity(courseApplication, "updateCourseApplication");
  const getProgramInfo = modelUtils.getModelEntity(program, "getProgramById");
  const getProgramEntityList = modelUtils.getModelEntity(programEntity, "getProgramEntityList");
  const addSchedule = modelUtils.getModelEntity(scheduleManagement, "addSchedule");
  const updateSchedule = modelUtils.getModelEntity(scheduleManagement, "updateSchedule");
  const courseware = modelUtils.getModelEntity(coursewareManagement, "coursewareManagement@coursewareInfo");
  const personInfo = modelUtils.getModelEntity(personManage, "getPersonInfoByPersonIdList");
  const load = modelUtils.getLoadingState(state, ['scheduleManagement', 'coursewareManagement', 'personManage']);
  return {
    getInfo,
    newConfirmedInfo,
    addCourseApplication: addCourseApplication,
    updateCourseApplication,
    addSchedule: addSchedule,
    updateSchedule: updateSchedule,
    courseware: courseware,
    personInfo: personInfo,
    getProgramInfo,
    getProgramEntityList,
    ...load
  }
};

export default connect(mapStateToProps)(ScheduleDetail);
